import {RootDesc} from "@/components/ui/descriptions/RootDesc";

import {ControlButton} from "@ui/buttons/ControlButton";
import {useTranslation} from "react-i18next";

import styles from "./styles.module.scss";

export const AvatarErrorPopup = (props) => {
  const {onClickTryAgain, onClickExit, detailedMessage = ""} = props;
  const {t} = useTranslation();

  return (
    <div className={styles.deletePopup}>
      <h2 dangerouslySetInnerHTML={{__html: t("popup.avatar_error.title")}} />
      {detailedMessage && (
        <RootDesc>
          <p style={{color: "var(--grey)", textAlign: "center"}}>
            {detailedMessage}
          </p>
        </RootDesc>
      )}

      <div className={styles.buttons}>
        <ControlButton
          color={"var(--blue)"}
          txt={t("button.again")}
          onClick={onClickTryAgain}
        />

        <ControlButton
          color={"var(--green)"}
          txt={t("button.exit_simulation")}
          onClick={onClickExit}
        />
      </div>
    </div>
  );
};
